import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  ConfigProvider,
  Image,
  Card,
  Radio,
  Modal,
  Form,
  Input,
  Divider,
} from "antd";
import {
  LoadingOutlined,
  CloseOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate, Link } from "react-router-dom";

import Learningpoints from "../assets/images/svgs/ic_learningpoints_programdesc.svg";

// for translate
import { useTranslation } from "react-i18next";

import {
  colorTextList,
  colorTextDesc,
  ColorPrimary,
  ColorSecondary,
  textUserPhoto,
  backgroundCard,
  colorTextTitle,
} from "../config/constant/color/index";
// import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

const ModalPointHistory = ({
  isOpenPointHistory,
  setIsOpenPointHistory,
  pointHistoryData,
  setPointHistoryData,
  points,
  dateModuleConvert,
  isMobileVersion,
}) => {
  const { t, i18n } = useTranslation();
  const [paddingBodyColumn, setPaddingBodyColumn] = useState(0);

  // const screens = useBreakpoint();
  // const isMobileVersion = screens.xs;
  const isScallingVersion =
    (window.innerWidth <= 991 && window.innerWidth >= 768) ||
    window.innerWidth === 581;

  const navigate = useNavigate();

  const bodyColumnStyleEmpty = {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const bodyColumnStyleNotEmpty = {
    height: "auto",
    maxHeight:
      isMobileVersion || isScallingVersion ? "45vh" : "calc(100vh - 353px)",
    overflowX: "hidden",
    overflowY: "auto",
    paddingRight: paddingBodyColumn,
  };

  const scrollActive = () => {
    var div = document.getElementById("body-column");

    var hasVerticalScrollbar = div.scrollHeight > div.clientHeight;

    if (hasVerticalScrollbar) {
      setPaddingBodyColumn(isMobileVersion ? 8 : 21);
    } else {
      setPaddingBodyColumn(isMobileVersion ? 8 : 26);
    }
  };

  const goToMyLj = () => {
    setIsOpenPointHistory(false);
    navigate("/my-learning-journey");
  };

  const numberWithDot = (x) => {
    if (x !== null && x !== undefined) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  };

  useEffect(() => {
    if (isOpenPointHistory === true) {
      setTimeout(() => {
        scrollActive();
      }, 100);
    }
    if (isOpenPointHistory === false) setPaddingBodyColumn(0);
  }, [isOpenPointHistory]);

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Roboto",
          borderRadiusLG: 16,
        },
      }}
    >
      <Modal
        className="modal-point-history"
        open={isOpenPointHistory}
        maskClosable={false}
        closeIcon={
          !isMobileVersion && (
            <div
              style={{
                padding: "6px",
                display: "flex",
                background: backgroundCard,
                borderRadius: "50%",
                border: "none",
              }}
              id="btn-modal-close-point-history"
            >
              <CloseOutlined
                style={{
                  color: colorTextDesc,
                  fontSize: "20px",
                  strokeWidth: "30",
                }}
              />
            </div>
          )
        }
        width={
          isMobileVersion ? (isScallingVersion ? `${585 * 0.9}px` : "90%") : 770
        }
        onCancel={() => {
          setIsOpenPointHistory(false);
          setPointHistoryData([]);
          // handleCloseUpdate();
        }}
        transitionName="ant-fade"
        keyboard
        centered
        footer={false}
        title={
          <div
            style={{
              padding: isMobileVersion
                ? "20px 12px 10px 12px"
                : "26px 26px 12px 26px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <img
              src={Learningpoints}
              style={{
                width: isMobileVersion ? 24 : 32,
                height: isMobileVersion ? 24 : 32,
              }}
              alt="Learning Points"
            />
            <div
              style={{
                fontSize: isMobileVersion ? 18 : 22,
                fontWeight: "bold",
                color: textUserPhoto,
                marginLeft: 12,
              }}
            >
              {t(
                "feature.home.pop_up_learning_history.learning_points_history",
              )}
            </div>
          </div>
        }
        style={{
          borderRadius: 16,
          maxHeight: isMobileVersion ? "90vh" : "unset",
        }}
      >
        <div
          className="point-info"
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: isMobileVersion ? "0 12px" : "0 26px",
            marginBottom: 20,
            gap: isMobileVersion ? 12 : 0,
          }}
        >
          <div
            className="earn-balance"
            style={{
              width: 349,
              borderRadius: isMobileVersion ? 6 : 16,
              display: "flex",
              flexDirection: isMobileVersion ? "column" : "row",
              alignItems: isMobileVersion ? "start" : "center",
              justifyContent: "space-between",
              padding: isMobileVersion ? "8px" : "16px 20px",
              color: backgroundCard,
            }}
          >
            <div
              style={{ fontSize: isMobileVersion ? 12 : 16, fontWeight: 500 }}
            >
              {t("feature.home.pop_up_learning_history.you_have_earned")}
            </div>
            <div
              style={{
                fontSize: isMobileVersion ? 18 : 22,
                fontWeight: "bold",
              }}
            >
              {numberWithDot(
                pointHistoryData.reduce(
                  (n, { points_get }) => n + parseInt(points_get),
                  0,
                ),
              )}{" "}
              {t("feature.home.pop_up_learning_history.points")}
            </div>
          </div>
          <div
            className="current-balance"
            style={{
              width: 349,
              borderRadius: isMobileVersion ? 6 : 16,
              display: "flex",
              flexDirection: isMobileVersion ? "column" : "row",
              alignItems: isMobileVersion ? "start" : "center",
              justifyContent: "space-between",
              padding: isMobileVersion ? "8px" : "16px 20px",
              color: backgroundCard,
            }}
          >
            <div
              style={{ fontSize: isMobileVersion ? 12 : 16, fontWeight: 500 }}
            >
              {t("feature.home.pop_up_learning_history.current_balance")}
            </div>
            <div
              style={{
                fontSize: isMobileVersion ? 18 : 22,
                fontWeight: "bold",
              }}
            >
              {numberWithDot(points)}{" "}
              {t("feature.home.pop_up_learning_history.points")}
            </div>
          </div>
        </div>
        <div
          className="body-history"
          style={{
            background: backgroundCard,
            borderRadius: 16,
            padding: isMobileVersion ? "12px 0 12px 12px" : "20px 0 20px 26px",
            height: pointHistoryData.length > 0 ? "auto" : 160,
          }}
        >
          <div
            className="head-column"
            style={{
              paddingRight: 26,
              fontSize: 14,
              fontWeight: 500,
              display: pointHistoryData.length > 0 ? "block" : "none",
            }}
          >
            {!isMobileVersion && (
              <Row style={{ paddingBottom: 20 }}>
                <Col span={15}>
                  {t("feature.home.pop_up_learning_history.module")}
                </Col>
                <Col span={7}>
                  {t("feature.home.pop_up_learning_history.completion_date")}
                </Col>
                <Col span={2} style={{ textAlign: "right" }}>
                  {t("feature.home.pop_up_learning_history.points")}
                </Col>
              </Row>
            )}
          </div>
          <div
            className="body-column"
            id="body-column"
            style={
              pointHistoryData.length == 0
                ? bodyColumnStyleEmpty
                : bodyColumnStyleNotEmpty
            }
          >
            {pointHistoryData.length > 0 ? (
              pointHistoryData.map((item, index) => (
                <Row
                  key={isMobileVersion ? `list-point-${index}` : item.id}
                  className={`row-list-point-history ${
                    isMobileVersion ? "mobile-version" : ""
                  }`}
                  style={{
                    padding:
                      index === pointHistoryData.length - 1
                        ? isMobileVersion
                          ? "8px 0px"
                          : "20px 0 0 0"
                        : isMobileVersion
                        ? "8px 0px 6px 0px"
                        : "20px 0",
                    alignContent: isMobileVersion ? "start" : "center",
                    justifyContent: isMobileVersion ? "space-between" : "unset",
                  }}
                >
                  {isMobileVersion ? (
                    <>
                      <Col span={21}>
                        {item.others !== undefined && item.others === true ? (
                          <span
                            style={{
                              color: colorTextList,
                              fontSize: 14,
                              fontWeight: 400,
                            }}
                          >
                            Others
                          </span>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "start",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            <span
                              style={{
                                color: colorTextTitle,
                                fontSize: 14,
                                fontWeight: 400,
                              }}
                            >
                              {item.module_name}
                            </span>
                            <span
                              style={{
                                color: colorTextDesc,
                                fontSize: 12,
                                fontWeight: 400,
                              }}
                            >
                              {item.others !== undefined && item.others === true
                                ? null
                                : "Completed " +
                                  dateModuleConvert(item.completed_date)}
                            </span>
                          </div>
                        )}
                      </Col>
                      <Col
                        span={3}
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          justifyContent: "flex-end",
                          paddingRight: 12,
                          color:
                            item.others !== undefined && item.others === true
                              ? colorTextList
                              : ColorPrimary,
                        }}
                      >
                        +{numberWithDot(parseInt(item.points_get))}
                      </Col>
                    </>
                  ) : (
                    <>
                      <Col span={15} style={{ paddingRight: 24 }}>
                        {item.others !== undefined && item.others === true ? (
                          <span style={{ color: colorTextList }}>Others</span>
                        ) : (
                          item.module_name
                        )}
                      </Col>
                      <Col span={7} style={{ alignContent: "center" }}>
                        {item.others !== undefined && item.others === true
                          ? null
                          : dateModuleConvert(item.completed_date)}
                      </Col>
                      <Col
                        span={2}
                        style={{
                          textAlign: "right",
                          alignContent: "center",
                          color:
                            item.others !== undefined && item.others === true
                              ? colorTextList
                              : ColorPrimary,
                        }}
                      >
                        +{numberWithDot(parseInt(item.points_get))}
                      </Col>
                    </>
                  )}
                </Row>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    fontSize: 14,
                    fontWeight: isMobileVersion ? 400 : 500,
                    color: colorTextDesc,
                  }}
                >
                  <div>
                    {t(
                      "feature.home.pop_up_learning_history.no_learning_points_history",
                    )}
                  </div>
                  <div>
                    {t(
                      "feature.home.pop_up_learning_history.click_button_bellow",
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* <div className='footer-history' style={{display:"flex",justifyContent:"center",fontSize:14,fontWeight:500,color:"#FFFFFF",padding:"12px 0 10px 0"}}> */}
        <div
          className="footer-history"
          style={{
            display: "flex",
            justifyContent: "center",
            fontSize: 14,
            fontWeight: 500,
            color: backgroundCard,
            padding: isMobileVersion ? "0 12px 12px 12px" : "10px 0",
            flexDirection: isMobileVersion ? "column" : "row",
            gap: isMobileVersion ? 12 : 0,
          }}
        >
          <div
            style={{
              margin: isMobileVersion ? "10px 0 20px 0" : 0,
              textAlign: isMobileVersion ? "center" : "unset",
              fontSize: 14,
            }}
          >
            <a onClick={() => goToMyLj()}>
              {t(
                "feature.home.pop_up_learning_history.learn_more_to_earn_more",
              )}
              <RightOutlined style={{ marginLeft: 6 }} />
            </a>
          </div>
          {isMobileVersion && (
            <div style={{ marginBottom: isMobileVersion ? "10px" : 0 }}>
              <Button
                onClick={() => setIsOpenPointHistory(false)}
                role="button"
                className="btn btn-sm btn-block"
                style={{
                  background: ColorSecondary,
                  color: ColorPrimary,
                  borderRadius: "6px",
                  border: "none",
                  fontWeight: "500",
                  height: "40px",
                  fontSize: "14px",
                  width: "100%",
                }}
              >
                Close
              </Button>
            </div>
          )}
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ModalPointHistory;
